export default "__VITE_ASSET__b820de74__"